module.exports = __webpack_public_path__ + "images/baa3d5b69b5d0b5395fa0b9da7c1f365.svg";